// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picture{display:inline-block;width:100%;transition:opacity .2s;overflow:hidden}.picture:not(.loaded){background:linear-gradient(25deg,var(--light) 40%,var(--gray) 200%);opacity:.3;height:100%;min-height:50px;font-size:0}.picture img{width:auto;max-width:100%;height:auto;margin:0 auto}", ""]);
// Exports
module.exports = exports;
